// extracted by mini-css-extract-plugin
module.exports = {"button":"BlockButton_button__QMsRV","buttonOutline":"BlockButton_buttonOutline__JC4Kw"};